import React, { useEffect } from "react";
import Layout from "./Layout";
import MaterialCurrentStock from "../components/MaterialCurrentStock";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getMe } from "../features/authSlice.js";

function CurrentStock() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isError, user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError) {
      navigate("/");
    }
    // Adjust the conditional redirection logic based on user credentials
    // In this case, if the user doesn't have necessary access rights, redirect to dashboard
    // if (user && user.user_lvl !== "1") {
    //   navigate("/dashboard");
    // }
  }, [isError, navigate]);

  return (
    <>
      {user && (
        <Layout>
          <MaterialCurrentStock />
        </Layout>
      )}
      {/* Add loading logic or handle unauthorized access */}
    </>
  );
}

export default CurrentStock;
